import type { OperatorScorecardStatsDto } from './operator-scorecard.types';

/** Stand-in payload until the operator scorecard stats API is designed. */
export const OPERATOR_SCORECARD_STATS_MOCK: OperatorScorecardStatsDto = {
  siteCount: 28,
  summary: {
    overallCompliance: { score: 86, max: 100 },
    averageResponseHours: { value: 1.3, target: 0.9 },
    averageFixHours: { value: 5.8, target: 4 },
    overallAvailabilityPercent: { value: 98.7, target: 96 },
  },
  operators: [
    {
      id: 'operator-1',
      name: 'Operator 1',
      summary: 'Your best operator — consistently meets SLA targets.',
      responseHours: 0.8,
      uptimePercent: 99.2,
      sitesRun: 12,
      penaltiesEuros: 0,
      performancePercent: 94,
      performanceBand: 'excellent',
    },
    {
      id: 'operator-2',
      name: 'Operator 2',
      summary: 'Solid overall — watch response time on peak days.',
      responseHours: 1.4,
      uptimePercent: 97.8,
      sitesRun: 8,
      penaltiesEuros: 1200,
      performancePercent: 78,
      performanceBand: 'good',
    },
    {
      id: 'operator-3',
      name: 'Operator 3',
      summary: 'Weakest — review contract terms and escalate breaches.',
      responseHours: 2.1,
      uptimePercent: 94.1,
      sitesRun: 8,
      penaltiesEuros: 4800,
      performancePercent: 42,
      performanceBand: 'needsImprovement',
    },
  ],
  failingSites: [
    {
      id: 'site-a',
      site: 'Site A',
      region: 'Paris Nord',
      performanceCurrent: 137,
      performanceMax: 142,
      operator: 'NordServ',
      status: 'urgent',
    },
    {
      id: 'site-b',
      site: 'Site B',
      region: 'Lyon Centre',
      performanceCurrent: 140,
      performanceMax: 142,
      operator: 'NordServ',
      status: 'watching',
    },
    {
      id: 'site-c',
      site: 'Site C',
      region: 'Marseille',
      performanceCurrent: 142,
      performanceMax: 142,
      operator: 'SudElec',
      status: 'good',
    },
    {
      id: 'site-d',
      site: 'Site D',
      region: 'Bordeaux',
      performanceCurrent: 138,
      performanceMax: 142,
      operator: 'OuestPower',
      status: 'watching',
    },
    {
      id: 'site-e',
      site: 'Site E',
      region: 'Lille',
      performanceCurrent: 141,
      performanceMax: 142,
      operator: 'NordServ',
      status: 'good',
    },
  ],
  urgentSiteCount: 2,
};
